import React from 'react'
import styled, { withTheme, css } from 'styled-components'
import FilterInput from './ExpressFilterInput'
import contentTypes from '../../constants/content-types'
import { SocialMediaContainer } from '../../containers'
import PropTypes from 'prop-types'
import { useAppContext } from '../../containers/App/Context'

/** V$-specific to capitalize the first letter  */
const v4 = css`
  background-color: unset;

  h1 {
    text-transform: lowercase;
    color: var(--clr-accent-to-white);
  }

  h1:first-letter {
    text-transform: uppercase;
  }
`

const Wrapper = styled.div`
  position: relative;
  width: 96%;
  margin: 0 auto;
  height: 160px;
  background-color: var(--clr-grey-7-to-text);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;

  ${props => props.version === 'v4' && v4}
`

const StyledSocialMediaContainerWrapper = styled.div`
  .share_title {
    color: var(--clr-grey-3-to-black) !important;
  }
`

const Title = styled.h1`
  color: var(--clr-grey-3-to-white);
  font-size: var(--h2);
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  padding: 0px 40px;

  @media only screen and (max-width: 768px) {
    font-size: var(--h3);
  }
`

const ExpressFilter = ({
  language,
  handleChange,
  inputValue,
  theme,
  clearInputValue,
  contentId,
  contentTitle
}) => {
  const contentType = 'faq'
  const { versionKey: version } = useAppContext()

  return (
    <Wrapper version={version}>
      {!inputValue && (
        <StyledSocialMediaContainerWrapper>
          <SocialMediaContainer
            contentId={contentId}
            contentType={contentType}
            contentTitle={contentTitle}
            version={version}
          />
        </StyledSocialMediaContainerWrapper>
      )}
      <Title theme={theme}>{contentTypes[language].faqLong}</Title>
      <FilterInput
        clearInputValue={clearInputValue}
        handleChange={handleChange}
        language={language}
        inputValue={inputValue}
        theme={theme}
      />
    </Wrapper>
  )
}

ExpressFilter.propTypes = {
  language: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  inputValue: PropTypes.string.isRequired,
  theme: PropTypes.object,
  clearInputValue: PropTypes.func.isRequired,
  contentId: PropTypes.string,
  contentTitle: PropTypes.func.isRequired,
  windowWidth: PropTypes.number
}

export default withTheme(ExpressFilter)



// WEBPACK FOOTER //
// ./src/components/ExpressHelp/ExpressFilter.js